import { Minigame } from 'src/replicant/minigame';
import features from 'src/replicant/ruleset/features';
import { State } from 'src/replicant/State';

export type GiftsSocialFriend = {
  readonly id?: string;
  readonly name?: string;
  readonly photo?: string;
  readonly hasGift?: boolean;
  readonly canSend?: boolean;
  readonly canCollect?: boolean;
};

/**
 * Sort friends by defined rules
 */
export function sortFriendsForGifting(friends: GiftsSocialFriend[]) {
  return friends.sort((a, b) => {
    // Group one
    // There is uncollected energy sent from the friend
    // The player can still send energy to the friend on that day
    const groupOneA = a.hasGift && a.canSend;
    const groupOneB = b.hasGift && b.canSend;
    if (groupOneA !== groupOneB) {
      return groupOneA ? -1 : 1;
    }

    // Group two
    // The player can still send energy to the friend on that day
    // There is NOT uncollected energy sent from the friend
    const groupTwoA = !a.hasGift && a.canSend;
    const groupTwoB = !b.hasGift && b.canSend;
    if (groupTwoA !== groupTwoB) {
      return groupTwoA ? -1 : 1;
    }

    // Group three
    // The player can NOT send energy to the friend on that day any more
    // There is uncollected energy sent from the friend
    const groupThreeA = a.hasGift && !a.canSend;
    const groupThreeB = b.hasGift && !b.canSend;
    if (groupThreeA !== groupThreeB) {
      return groupThreeA ? -1 : 1;
    }

    // Group four
    // The player can NOT send energy to the friend on that day any more
    // There is NOT uncollected energy sent from the friend
    const groupFourA = !a.hasGift && !a.canSend;
    const groupFourB = !b.hasGift && !b.canSend;
    if (groupFourA !== groupFourB) {
      return groupFourA ? -1 : 1;
    }

    return -1;
  });
}

/**
 * Have criteria for unlocking gift feature been met
 */
export const hasMetGiftsUnlockCriteria = (state: State) =>
  Minigame.getters(state).areMinigamesAvailable();

/**
 * Is gift feature unlocked
 */
export function isGiftsFeatureUnlocked(state: State): boolean {
  return features(state).gifts && hasMetGiftsUnlockCriteria(state);
}

/**
 * Check if we have not collected gifts
 */
export function hasGiftsMessages(state: State): boolean {
  return Object.keys(state.gifts.received).length !== 0;
}
